export default __webpack_public_path__ + "static/media/help.668a222c.svg";